import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  href?: string;
  showBadges?: boolean;
}
export function Button({
  children,
  className = '',
  href,
  showBadges = false,
  ...props
}: ButtonProps) {
  const baseClasses = 'relative inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-white transition-all duration-200 bg-brand-green border border-transparent rounded-full hover:bg-brand-light focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-light focus:ring-offset-brand-dark shadow-[0_0_20px_rgba(34,197,94,0.3)] hover:shadow-[0_0_30px_rgba(34,197,94,0.5)]';
  const content = <motion.div whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className="w-full" data-id="element-53">
      {href ? <a href={href} className={`${baseClasses} w-full text-center ${className} text-[18px] font-[700] font-sans mb-[0px]`} data-id="element-54">
          {children}
        </a> : <button className={`${baseClasses} w-full ${className}`} {...props} data-id="element-55">
          {children}
        </button>}
      {showBadges && <div className="flex items-center justify-center gap-4 mt-3 text-[11px] md:text-xs text-gray-400" data-id="element-56">
          <span className="flex items-center gap-1.5" data-id="element-57">
            <span className="w-2.5 h-2.5 rounded-full bg-green-500 inline-block shrink-0" data-id="element-58" />
            Garantía 30 días
          </span>
          <span className="flex items-center gap-1.5" data-id="element-59">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-3.5 h-3.5 text-gray-400 shrink-0" data-id="element-60">
              <rect width="18" height="11" x="3" y="11" rx="2" ry="2" data-id="element-61" />
              <path d="M7 11V7a5 5 0 0 1 10 0v4" data-id="element-62" />
            </svg>
            Pago seguro
          </span>
          <span className="flex items-center gap-1.5" data-id="element-63">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-3.5 h-3.5 text-gray-400 shrink-0" data-id="element-64">
              <path d="m11 17 2 2a1 1 0 1 0 3-3" data-id="element-65" />
              <path d="m14 14 2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4" data-id="element-66" />
              <path d="m21 3 1 11h-2" data-id="element-67" />
              <path d="M3 3 2 14l6.5 6.5a1 1 0 1 0 3-3" data-id="element-68" />
              <path d="M3 4h8" data-id="element-69" />
            </svg>
            Mercado Pago
          </span>
        </div>}
    </motion.div>;
  return content;
}